<template>
  <div class="router-loading">
    <template v-if="!timedOut">
      <div class="spinner" />
      <p>路由加载中</p>
    </template>
    <el-result
      v-else
      icon="warning"
      title="页面加载失败"
      sub-title="路由信息未能及时加载，请刷新重试或返回应用首页。"
    >
      <template #extra>
        <el-button type="primary" @click="reload">刷新重试</el-button>
        <el-button @click="goHome">返回应用首页</el-button>
      </template>
    </el-result>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

defineOptions({ name: 'RouterLoading' })

const route = useRoute()
const router = useRouter()
const timedOut = ref(false)
let retryTimer: number | undefined
const timer = window.setTimeout(() => {
  timedOut.value = true
}, 8000)

const reload = () => window.location.reload()
const goHome = () => {
  const segments = route.path.split('/').filter(Boolean)
  const centerRoot = segments.length >= 2 ? `/${segments[0]}/${segments[1]}` : '/'
  router.push(centerRoot)
}

/** 动态路由稍后才挂上时，主动 rematch，避免一直停在本占位页 */
onMounted(() => {
  retryTimer = window.setTimeout(() => {
    if (timedOut.value) return
    void router.replace({ path: route.fullPath, query: route.query, hash: route.hash })
  }, 600)
})

onBeforeUnmount(() => {
  window.clearTimeout(timer)
  if (retryTimer) window.clearTimeout(retryTimer)
})
</script>

<style scoped>
.router-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px;
}
.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e7eb;
  border-top-color: #409eff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
p {
  margin: 16px 0 0;
  font-size: 13px;
  color: #909399;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
